<template>
    <project-step-container
            prev-to="be_rapid_experiments_with_customers_19"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row>
            <b-col cols="12" class="main-text pb-3" tabindex="0">
              {{getMessage(20, 'rapidexperiment-sub')}}
            </b-col>
        </b-row>
   
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"  :text="getMessage(20, 'rapidexperiment-guide')" ></LinkStyleGuide>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(20, 'if')}}</label>
                <input id="first-thing" type="text" v-model="form.if"
                 :placeholder="getMessage(20, 'ifplaceholder')"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(20, 'then')}}</label>
                <input id="second-thing" type="text" v-model="form.then"  :placeholder="getMessage(20, 'thenplaceholder')"
               />
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(20, 'measure')}}</label>
                <input id="third-thing" type="text" v-model="form.measure"  :placeholder="getMessage(20, 'measureplaceholder')"
                      />
            </b-col>
            <b-col cols="12" class="mt-4">
                <label for="four-thing">{{getMessage(20, 'metric')}}</label>
                <input id="four-thing" type="text" v-model="form.metric"  :placeholder="getMessage(20, 'metricplaceholder')"
                       />
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";

    export default {
        name: "RapidExperimentsWithCustomers20",
        components: {ProjectStepContainer , LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_HYPOTHESIS,
                urlNextProject:'be_rapid_experiments_with_customers_21',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.TEST_HYPOTHESIS_TEST_PLAN),
                form: {
                    if: "",
                    then: "",
                    measure: "",
                    metric: ""
                }
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

